<div class="gridItemChildModule w-100 h-100 d-flex flex-column" id="gauge-body-{{moduleKey}}" #gaugeBody>
    <div style="height: 50%;width: 100%;" class="mt-5 text-center" id="empty-gauge-div"
        *ngIf="!noData && !intervalRangeTooWide && gaugeData?.GaugeData?.Objective === null && !moduleManager.showLoader">
        <svg style="width:70%;height:70%" *ngIf="gaugeData?.GaugeData?.Objective === null && !moduleManager.showLoader"
            class="empty-gauge-svg">
            <use href="../App_Themes/CXone/icons/cxone-empty-gauge.svg#cxone-empty-gauge" height="100%" width="100%"
                id="empty-gauge-svg">
            </use>
        </svg>
        <label class="justify-content-center" id="metric-value">{{gaugeDisplayValue}}</label>
        <label class="justify-content-center metric-name" id="gauge-metric-name">{{gaugeData?.GaugeData?.MetricName}}</label>
        <label class="justify-content-center gauge-metric-type" id="gauge-metric-type">({{numberTypes[gaugeData?.GaugeData?.NumericType]}})</label>
    </div>
    <ng-container *ngIf="showColorIndicator">
        <div class="gauge-direction-container" id="direction-container"
            *ngIf="gaugeData?.GaugeData?.Objective !== null && !moduleManager.showLoader && !isDataLoading && !noData && !!gaugeData?.GaugeData?.Objective">
            <svg class="icon" id="direction-svg">
                <ng-container *ngIf="gaugeData?.GaugeData?.Direction === 0; else elseTemplate">
                    <use href="../App_Themes/CXone/icons/cxone-up-arrow.svg#up-arrow"></use>
                </ng-container>
                <ng-template #elseTemplate>
                    <use href="../App_Themes/CXone/icons/cxone-down-arrow.svg#down-arrow"></use>
                </ng-template>
            </svg>
            <span class="colors" id="color-slices">
                <span class="color" id="color-slice-{{i}}" [attr.data-title]="getToolTip(i)"
                    *ngFor="let color of gaugeColors; index as i"
                    [ngStyle]="{'background': color}"></span>
            </span>
        </div>
    </ng-container>
    <app-module-error class="flex-fill" *ngIf="intervalRangeTooWide" [intervalRangeTooWide]="true"></app-module-error>
    <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
    <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions"
        *ngIf="!noData && !intervalRangeTooWide && this.gaugeData?.GaugeData?.Objective !== null" id="gauge-chart">
    </highcharts-chart>
</div>
